import React from "react";
import Fade from "react-reveal/Fade";

/**
 * Section "Pourquoi choisir Yesshop ?"
 * Layout 2 colonnes : Image à gauche, Texte à droite (desktop)
 * Layout empilé verticalement sur mobile
 */
export const WhyChooseYesshopSection: React.FC = () => {
  const benefits = [
    {
      title: "Produits de qualité",
      description: "Nous sélectionnons avec soin chaque produit pour vous garantir la meilleure qualité.",
    },
    {
      title: "Livraison rapide et sécurisée",
      description: "Recevez vos commandes rapidement et en toute sécurité.",
    },
    {
      title: "Service client réactif",
      description: "Notre équipe est là pour répondre à toutes vos questions.",
    },
    {
      title: "Marketplace de confiance",
      description: "Des milliers de clients satisfaits nous font confiance chaque jour.",
    },
  ];

  return (
    <div className="why-choose-yesshop-section">
      <div className="why-choose-yesshop-container">
        <div className="why-choose-yesshop-content">
          {/* Colonne gauche - Image */}
          <Fade left>
            <div className="why-choose-yesshop-image-wrapper">
              <img
                src="/Group 1000004817.png"
                alt="Client satisfait Yesshop"
                className="why-choose-yesshop-image"
                loading="lazy"
              />
            </div>
          </Fade>

          {/* Colonne droite - Texte */}
          <div className="why-choose-yesshop-text-wrapper">
            <Fade right>
              <h2 className="why-choose-yesshop-title">
                Pourquoi choisir Yesshop ?
              </h2>
              <ul className="why-choose-yesshop-list">
                {benefits.map((benefit, index) => (
                  <li key={index} className="why-choose-yesshop-item">
                    <span className="why-choose-yesshop-item-title">
                      {benefit.title} :
                    </span>{" "}
                    <span className="why-choose-yesshop-item-description">
                      {benefit.description}
                    </span>
                  </li>
                ))}
              </ul>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
};
